import { TouchableOpacity } from 'react-native';
import { ReactComponent as CheckIcon } from '../../../assets/icons/check.svg';
import { COLORS } from '../../../config/colors';
import { THEME_COLORS } from '../../../theme/constants/themeColors';
import CText from '../../../ui/components/CText';
import { StyleHelpers } from '../../constants/style-helpers';
import { THEME_STYLES } from '../../../theme/constants/themeStyles';

export default function FilterRadioButton(props: any) {
  const { title, checked, onPress = () => { } } = props;
  return (
    <>
      <TouchableOpacity
        activeOpacity={0.7}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          ...THEME_STYLES.item,
          ...(checked ? THEME_STYLES.itemSelected : {}),
          // backgroundColor: checked ? COLORS.blackColor : THEME_COLORS.cardUnselectedBgColor,
          // ...StyleHelpers.themeBorder,
          // borderColor: checked ? THEME_COLORS.cardSelectedBorderColor : THEME_COLORS.cardUnselectedBorderColor,
          paddingVertical: 6,
          justifyContent: 'center',
        }}
        onPress={onPress}>
        {checked && (
          <CheckIcon
            fill={checked ? THEME_COLORS.primaryColor : THEME_COLORS.textColor}
            style={{
              height: 12,
              width: 12
            }}
          />
        )}
        <CText
          value={title}
          size={12}
          semiBold
          style={{
            color: checked ? THEME_COLORS.primaryColor : THEME_COLORS.textColor,
            marginStart: checked ? 5 : 0,
            marginTop: 0,
            paddingVertical: 4,
            fontWeight: '600'
          }}
        />
      </TouchableOpacity>
    </>
  );
}
